<template>
  <Modal :title="title" class="table-list group-design large" @submit="submit">
    <template v-slot:body>
      <div class="d-flex align-items-start">
        <TableList :config="configTable()"></TableList>
      </div>
    </template>
  </Modal>
</template>

<script>
import TableList from './../TableList.vue'
export default {
  components: {
    TableList
  },
  data() {
    return {
      ids: {}
    }
  },
  mounted() {
    this.$emitter.on('table-list.cb-changed', this.changeCb)
  },
  unmounted() {
    this.$emitter.off('table-list.cb-changed', this.changeCb)
  },
  computed: {
    title() {
      return 'Group Design'
    },
    storeId() {
      return this.config?.storeId
    },
    subDesign() {
      return this.config?.sub_design || []
    },
    submitUri() {
      return `design/group-design/${this.config?.data?.id}`
    }
  },
  methods: {
    configTable() {
      return {
        preload: true,
        showTableFilters: true,
        tableId: 'group-design',
        indexUri: `design`,
        storeId: ['group-design'],
        disabledRenderScreenOptions: true,
        disableMoreActions: true,
        showViewActions: true,
        hiddenCols: {
          cb: false
        }
      }
    },
    changeCb({ cb }) {
      Object.entries(cb).forEach(([id, checked]) => {
        if (checked) {
          this.ids[id] = true
        } else if (this.ids[id] != undefined) {
          delete this.ids[id]
        }
      })
    },
    submit() {
      this.$util
        .post(this.submitUri, {
          ids: Object.keys(this.ids)
        })
        .then((response) => {
          if (response.status == 'success') {
            this.$emit('close')
            this.$emitter.emit('Modal.Design.Refresh')
          }
        })
    }
  },
  props: {
    config: Object
  }
}
</script>
